export default {
  send: 'Envoyer',
};
